<template>
    <div>
    <!-- 特色创客空间建设项目 -->
      <resultDetail_MakerSpace v-if="$route.query['tid']=='5f7a66d5-c206-11ed-a4cd-509a4c5b67cf'"/>
      <!-- 学生创业项目 -->
      <resultDetail_student v-if="$route.query['tid']=='5e21b204-c206-11ed-a4cd-509a4c5b67cf'"></resultDetail_student>
    </div>
  
</template>

  <script>
// 特色创客空间建设项目
import resultDetail_MakerSpace from './components/resultDetail_MakerSpace.vue';
import resultDetail_student from './components/resultDetail_student.vue';
      export default {
        components:{resultDetail_MakerSpace,resultDetail_student},
        data() {
          return {

          }
        },
        methods:{

        },
        mounted(){

        }
      }
  </script>
  
  <style lang="less" scoped>
    
  </style>